import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const Reveal = ({ children, className = "", i = 0 }) => (
  <motion.div
    className={className}
    custom={i}
    variants={fadeUp}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] ${
      dark ? "text-zinc-400" : "text-zinc-500"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-zinc-600" : "bg-zinc-400"}`} />
    {children}
  </span>
);
